import { repairSmithFieldOps } from './getRepairSmithFieldOps';

export const isDevelopment = () => {
  const { NODE_ENV = 'development' } = repairSmithFieldOps;
  return NODE_ENV === 'development';
};

export default isDevelopment;
